const value = {
    noSystems: 'No systems available',
    finished: 'Finished',
  };

export default value;
